const state = {
    isVCardShowing: false,
    vCardLink: ''
}
  
export default state
  